import { useSearchParams } from "react-router-dom";

/** @returns Whether the page is inspecting an explicitly requested revision. */
export function useIsDataPreparationReadOnly(): boolean {
  const [searchParams] = useSearchParams();
  return searchParams.has("revisionId");
}
